import { lazy, JSX, ComponentProps } from 'react';
import { LazyComponent } from '@bg-components/LazyComponent';

const Component = lazy(() => import('./HeroProfileNavigationItem'));

export const HeroProfileNavigationItem = (props: ComponentProps<typeof Component>): JSX.Element => (
    <LazyComponent>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Component {...props} />
    </LazyComponent>
);
